<template>
  <div class="InstitutionAppointment" style="margin-bottom: 8rem;">
    <app-breadcrumb :items="items" />

    <content-loader :is-loading="isLoading">
      <s-wrapper>
        <b-container>
          <b-row>
            <b-col lg="6">
              <institution-details :institution="institution" />
            </b-col>
            <b-col lg="6">
              <institution-schedule />
            </b-col>
          </b-row>
        </b-container>
      </s-wrapper>
    </content-loader>
  </div>
</template>

<script>
import styled from "vue-styled-components";
import AppBreadcrumb from "../components/AppBreadcrumb";
import ContentLoader from "../components/ContentLoader.vue";
import InstitutionDetails from "../components/Institution/InstitutionDetails";
import InstitutionSchedule from "../components/Institution/InstitutionSchedule";

export const SWrapper = styled.div`
  margin-top: 60px;
  width: 100%;
`;

export default {
  name: "InstitutionAppointment",
  components: {
    AppBreadcrumb,
    ContentLoader,
    InstitutionDetails,
    InstitutionSchedule,
    SWrapper
  },
  data() {
    return {
      items: [
        {
          text: "Home",
          link: "/"
        },
        {
          text: "Especialistas e Clínicas",
          link: "/clinicas"
        }
      ],
      institution: {}
    };
  },
  mounted() {
    this.fetchInstitution();
    this.fetchInstitutionsUnits();
  },
  methods: {
    async fetchInstitution() {
      const response = await this.$store.dispatch(
        "institutions/fetchInstitution",
        this.$route.params.id
      );
      this.institution = response.data;
      this.items.push({ text: response.data.name });
    },
    async fetchInstitutionsUnits() {
      await this.$store.dispatch(
        "institutions/fetchInstitutionsUnits",
        this.$route.params.id
      );
    }
  },
  computed: {
    isLoading() {
      return this.$store.getters["institutions/isLoading"];
    }
  }
};
</script>
